import {
  Component,
  HostListener,
  OnInit,
  inject,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FlightSearchService } from '../../../services/flight-search/services/flight-search.service';
import { SharedService } from '../../../services/shared.service';
import Swal from 'sweetalert2';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-calander-mobile-view',
  templateUrl: './calender-mobile-view.component.html',
  styleUrls: ['./calender-mobile-view.component.scss'],
})
export class CalenderMobileViewComponent implements OnInit {
  private isBrowser: boolean;

  searchbox = inject(FlightSearchService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  translate = inject(TranslateService);
  sharedService = inject(SharedService);
  public screenWidth: number = 650;
  flightIndex: number = 0;
  flightType?: string;
  hoveredDate: NgbDate | null = null;
  fromDate?: NgbDate;
  startDateValue: any;
  toDate: NgbDate | null = null;
  showPicker: boolean = true;
  minDate!: NgbDate;
  minReturnDate: NgbDate = new NgbDate(1789, 7, 14);
  lang: string = 'en';
  index: number = 0;

  constructor(
    public calendar: NgbCalendar,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.minDate = this.calendar.getToday();

    if (
      this.isBrowser &&
      this.searchbox.flightsArray?.at(0).get('departingD')?.value
    ) {
      this.fromDate = calendar.getToday();
      this.fromDate.year = new Date(
        this.searchbox.flightsArray.at(0).get('departingD')?.value,
      ).getFullYear();
      this.fromDate.month =
        new Date(
          this.searchbox.flightsArray.at(0).get('departingD')?.value,
        ).getMonth() + 1;
      this.fromDate.day = new Date(
        this.searchbox.flightsArray.at(0).get('departingD')?.value,
      ).getDate();

      this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
      this.toDate.year = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getFullYear();
      this.toDate.month =
        new Date(
          this.searchbox.searchFlight.get('returnDate')?.value,
        ).getMonth() + 1;
      this.toDate.day = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getDate();
    } else {
      this.fromDate = calendar.getToday();
      this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.screenWidth = window.innerWidth;
    }

    this.flightType = this.searchbox.searchFlight.get('flightType')?.value;
    this.route.paramMap.subscribe((params) => {
      const param = params.get('index');
      this.flightIndex = Number(param);
    });

    if (
      this.searchbox.searchFlight.get('flightType')?.value.toLowerCase() ===
      'roundtrip'
    ) {
      if (!this.isBrowser) {
        return; // Exit if running on the server
      }

      let day = 0;
      let month = 0;
      let year = 0;

      if (
        this.searchbox.flightsArray.at(this.flightIndex)?.get('departingD')
          ?.valid
      ) {
        year = new Date(
          this.searchbox.flightsArray
            .at(this.flightIndex)
            ?.get('departingD')?.value,
        ).getFullYear();
        month = new Date(
          this.searchbox.flightsArray
            .at(this.flightIndex)
            ?.get('departingD')?.value,
        ).getMonth();
        day = new Date(
          this.searchbox.flightsArray
            .at(this.flightIndex)
            ?.get('departingD')?.value,
        ).getDate();

        this.minReturnDate.month = month + 1;
        this.minReturnDate.year = year;
        this.minReturnDate.day = day + 1;
      } else {
        this.minReturnDate = this.calendar.getToday();
      }

      return this.startDateValue;
    }

    this.retStartDate();
  }

  retStartDate() {
    let day = 0;
    let month = 0;
    let year = 0;

    if (
      this.searchbox.flightsArray?.at(this.flightIndex).get('departingD')?.valid
    ) {
      year = new Date(
        this.searchbox.flightsArray
          ?.at(this.flightIndex)
          .get('departingD')?.value,
      ).getFullYear();
      month = new Date(
        this.searchbox.flightsArray
          ?.at(this.flightIndex)
          .get('departingD')?.value,
      ).getMonth();
      day = new Date(
        this.searchbox.flightsArray
          ?.at(this.flightIndex)
          .get('departingD')?.value,
      ).getDate();

      this.startDateValue = { year: year, month: month + 1, day: day };
    } else {
      this.startDateValue = this.calendar.getToday();
    }

    return this.startDateValue;
  }

  retStartDateR() {
    if (!this.isBrowser) {
      return; // Exit if running on the server
    }

    let day = 0;
    let month = 0;
    let year = 0;

    if (this.searchbox.searchFlight.get('returnDate')?.valid) {
      year = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getFullYear();
      month = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getMonth();
      day = new Date(
        this.searchbox.searchFlight.get('returnDate')?.value,
      ).getDate();

      this.startDateValue = { year: year, month: month + 1, day: day };
    } else {
      this.startDateValue = this.calendar.getToday();
    }

    return this.startDateValue;
  }

  isDisabled(date: NgbDate) {
    return date.before(this.minDate);
  }

  isDisabledR(date: NgbDate) {
    return date.before(this.fromDate);
  }

  backToSearchBox() {
    this.router.navigate(['/']);
    this.sharedService.roundTripDatepickerMobileView = false;
  }

  confirmDate() {
    if (this.isBrowser) {
      // ✅ Only access localStorage in the browser
      localStorage.setItem(
        'form',
        JSON.stringify(this.searchbox.searchFlight.value),
      );
    }

    this.backToSearchBox();
    this.sharedService.roundTripDatepickerMobileView = false;
  }

  onDateSelection(date: NgbDate) {
    this.searchbox.flightsArray
      .at(this.flightIndex)
      ?.get('departingD')
      ?.setValue(new Date(date.year, date.month - 1, date.day));

    if (
      this.searchbox.searchFlight.get('flightType')?.value === 'MultiCity' ||
      this.searchbox.searchFlight.get('flightType')?.value === 'Multicity' ||
      this.searchbox.searchFlight.get('flightType')?.value === 'multicity'
    ) {
      const errorMsg = this.searchbox.validateMultiCityDates();
      if (errorMsg.enMsg && errorMsg.enMsg !== 'True') {
        if (this.lang === 'en') {
          this.tinyAlert(errorMsg.enMsg);
        } else {
          this.tinyAlert(errorMsg.arMsg);
        }
      }
    }

    if (
      this.searchbox.searchFlight.get('flightType')?.value.toLowerCase() ===
      'roundtrip'
    ) {
      this.searchbox.searchFlight.get('returnDate')?.setValue('');
    }

    this.confirmDate();
  }

  onDateSelectionRound(date: NgbDate) {
    this.searchbox.searchFlight
      .get('returnDate')
      ?.setValue(new Date(date?.year, date?.month - 1, date?.day));

    if (this.isBrowser) {
      // ✅ Only access localStorage in the browser
      localStorage.setItem(
        'form',
        JSON.stringify(this.searchbox.searchFlight.value),
      );
    }

    this.backToSearchBox();
    this.sharedService.roundTripDatepickerMobileView = false;
  }

  isHovered(date: NgbDate) {
    return (
      this.startDateValue &&
      date.after(this.startDateValue) &&
      date.before(this.startDateValue)
    );
  }

  isInside(date: NgbDate) {
    return date.after(this.startDateValue) && date.before(this.startDateValue);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDateValue) ||
      (this.startDateValue && date.equals(this.startDateValue)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isHoveredR(date: NgbDate) {
    return this.toDate && date.after(this.toDate) && date.before(this.toDate);
  }

  isInsideR(date: NgbDate) {
    return date.after(this.toDate) && date.before(this.toDate);
  }

  isRangeR(date: NgbDate) {
    return (
      date.equals(this.toDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInsideR(date) ||
      this.isHoveredR(date)
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.isBrowser) {
      this.screenWidth = window.innerWidth;
    }
  }

  tinyAlert(message: any) {
    if (this.isBrowser) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: message,
      });
    }
  }
}
